/* Shalimar preview upgrade - Unze-style. Preview theme only. */
(function(){
var CSS = [
'.uz-bar{display:flex;gap:10px;flex-wrap:wrap;align-items:center;padding:14px 20px;border-bottom:1px solid #e7e2da;background:#fdfcfa;position:sticky;top:0;z-index:50}',
'.uz-chip{position:relative}',
'.uz-btn{font:inherit;font-size:14px;padding:9px 16px;border:1px solid #d9d2c7;background:#fff;border-radius:999px;cursor:pointer;color:#222;white-space:nowrap}',
'.uz-btn.on{background:#222;color:#fff;border-color:#222}',
'.uz-pop{display:none;position:absolute;top:44px;left:0;background:#fff;border:1px solid #e0d9cd;border-radius:12px;padding:14px;min-width:230px;box-shadow:0 12px 30px rgba(0,0,0,.12);z-index:60}',
'.uz-pop.open{display:block}',
'.uz-opt{display:flex;align-items:center;gap:9px;padding:6px 2px;font-size:14px;cursor:pointer}',
'.uz-opt input{width:16px;height:16px}',
'.uz-count{font-size:13px;color:#7A5C1E;margin-left:auto}',
'.uz-clear{font-size:13px;color:#666;text-decoration:underline;cursor:pointer;background:none;border:0}',
'.uz-hide{display:none !important}',
'.uz-empty{padding:50px 20px;text-align:center;color:#666;font-size:15px}',
'.uz-range{display:flex;gap:8px;align-items:center;margin-top:6px}',
'.uz-range input{width:78px;font:inherit;font-size:14px;padding:7px;border:1px solid #d9d2c7;border-radius:7px}',
'@media(max-width:700px){.uz-bar{padding:10px 12px;gap:7px;overflow-x:auto;flex-wrap:nowrap}.uz-btn{font-size:13px;padding:8px 13px}.uz-count{display:none}}'
].join('');
var s=document.createElement('style'); s.id='uz-css'; s.textContent=CSS; document.head.appendChild(s);


/* ---------- COLLECTION FILTERS ---------- */
function money(t){var m=String(t).replace(/[^0-9.,]/g,'').replace(/\.(?=\d{3})/g,'').replace(',','.');return parseFloat(m)||0;}
function initCollection(){
  var cards=[].slice.call(document.querySelectorAll('a.card'));
  if(!cards.length) return;
  var grid=cards[0].parentElement;
  if(document.getElementById('uz-bar')) return;
  var handle=(location.pathname.match(/\/collections\/([^\/?#]+)/)||[])[1];
  if(!handle) return;

  var DATA={};
  var sizes={}, colours={};

  function harvest(list){
    list.forEach(function(p){
      var sz={}, cl={}, avail=false, price=1e9, comp=0;
      p.variants.forEach(function(v){
        var parts=String(v.title).split('/').map(function(x){return x.trim();});
        parts.forEach(function(pt){
          var m=pt.match(/^uk\s*([0-9]+)$/i);
          if(m){ if(v.available){ sz[m[1]]=1; sizes[m[1]]=1; } }
        });
        var c=parts[0];
        if(c && !/^uk|^eu/i.test(c)){ cl[c]=1; colours[c]=1; }
        if(v.available) avail=true;
        var pr=parseFloat(v.price)||0; if(pr&&pr<price) price=pr;
        var ca=parseFloat(v.compare_at_price)||0; if(ca>comp) comp=ca;
      });
      if(price===1e9) price=0;
      DATA[p.handle]={sizes:Object.keys(sz),colours:Object.keys(cl),price:price,
        disc: comp>price&&comp?Math.round((1-price/comp)*100):0,
        created: p.created_at||'', avail:avail,
        imgs:(p.images||[]).map(function(im){return String(im.src).split('?')[0]+'?width=700';}).slice(0,6),
        blocks:(function(){
          var vc={}; (p.variants||[]).forEach(function(v){ vc[v.id]=String(v.option1||'').toLowerCase().trim(); });
          var blocks={}, order=[], cur=null;
          (p.images||[]).slice().sort(function(a,b){return (a.position||0)-(b.position||0);}).forEach(function(im){
            var ids=im.variant_ids||[];
            if(ids.length){ var c=vc[ids[0]]||''; if(c){ cur=c; if(!blocks[c]){blocks[c]=[];order.push(c);} } }
            if(cur){ if(blocks[cur].length<6) blocks[cur].push(String(im.src).split('?')[0]+'?width=700'); }
          });
          return {b:blocks,o:order};
        })()};
    });
  }

  function build(){
    var szList=Object.keys(sizes).sort(function(a,b){return a-b;});
    var clList=Object.keys(colours).sort();
    var bar=document.createElement('div');
    bar.className='uz-bar'; bar.id='uz-bar';
    function pop(id,label,opts,name){
      return '<div class="uz-chip"><button class="uz-btn" data-pop="'+id+'">'+label+'</button>'+
        '<div class="uz-pop" id="'+id+'">'+opts.map(function(o){
          return '<label class="uz-opt"><input type="checkbox" name="'+name+'" value="'+o.v+'">'+o.t+'</label>';
        }).join('')+'</div></div>';
    }
    var html='';
    if(szList.length) html+=pop('uz-size','Size',szList.map(function(s){return {v:s,t:'UK '+s};}),'size');
    if(clList.length>1) html+=pop('uz-col','Colour',clList.map(function(c){return {v:c,t:c};}),'colour');
    html+='<div class="uz-chip"><button class="uz-btn" data-pop="uz-price">Price</button><div class="uz-pop" id="uz-price">'+
      '<div class="uz-range"><input id="uz-min" type="number" placeholder="Min" min="0"><span>to</span><input id="uz-max" type="number" placeholder="Max" min="0"></div></div></div>';
    html+='<div class="uz-chip"><button class="uz-btn" data-pop="uz-sort">Sort</button><div class="uz-pop" id="uz-sort">'+
      ['featured|Featured','low|Price: low to high','high|Price: high to low','disc|Biggest discount','new|Newest in']
      .map(function(o){var p=o.split('|');return '<label class="uz-opt"><input type="radio" name="sort" value="'+p[0]+'"'+(p[0]==='featured'?' checked':'')+'>'+p[1]+'</label>';}).join('')+
      '</div></div>';
    html+='<button class="uz-clear" id="uz-clear">Clear all</button><span class="uz-count" id="uz-count"></span>';
    bar.innerHTML=html;
    grid.parentElement.insertBefore(bar,grid);
    var empty=document.createElement('div'); empty.className='uz-empty uz-hide'; empty.id='uz-empty';
    empty.textContent='No styles match. Try clearing a filter.';
    grid.parentElement.insertBefore(empty,grid.nextSibling);

    bar.addEventListener('click',function(e){
      var b=e.target.closest('[data-pop]');
      if(b){ var el=document.getElementById(b.getAttribute('data-pop'));
        var was=el.classList.contains('open');
        [].forEach.call(bar.querySelectorAll('.uz-pop'),function(p){p.classList.remove('open');});
        if(!was) el.classList.add('open');
        e.stopPropagation(); return; }
      if(e.target.id==='uz-clear'){
        [].forEach.call(bar.querySelectorAll('input[type=checkbox]'),function(i){i.checked=false;});
        document.getElementById('uz-min').value=''; document.getElementById('uz-max').value='';
        var f=bar.querySelector('input[value=featured]'); if(f) f.checked=true;
        apply();
      }
    });
    document.addEventListener('click',function(){ [].forEach.call(bar.querySelectorAll('.uz-pop'),function(p){p.classList.remove('open');}); });
    bar.addEventListener('change',apply);
    bar.addEventListener('input',function(e){ if(/uz-min|uz-max/.test(e.target.id)) apply(); });
  }

  function vals(name){ return [].slice.call(document.querySelectorAll('#uz-bar input[name="'+name+'"]:checked')).map(function(i){return i.value;}); }

  function apply(){
    var sz=vals('size'), cl=vals('colour');
    var mn=parseFloat((document.getElementById('uz-min')||{}).value)||0;
    var mx=parseFloat((document.getElementById('uz-max')||{}).value)||1e9;
    var sortEl=document.querySelector('#uz-bar input[name=sort]:checked');
    var sort=sortEl?sortEl.value:'featured';
    var shown=0;
    cards.forEach(function(c,idx){
      var h=(c.getAttribute('href')||'').split('/products/')[1];
      var d=DATA[h];
      var ok=true;
      if(d){
        if(sz.length && !sz.some(function(s){return d.sizes.indexOf(s)>-1;})) ok=false;
        if(cl.length && !cl.some(function(x){return d.colours.indexOf(x)>-1;})) ok=false;
        var pr=d.price||money((c.querySelector('.pr')||{textContent:''}).textContent);
        if(pr<mn||pr>mx) ok=false;
      }
      c.classList.toggle('uz-hide',!ok);
      if(ok) shown++;
      c.style.order='';
    });
    if(sort!=='featured'){
      var vis=cards.filter(function(c){return !c.classList.contains('uz-hide');});
      vis.sort(function(a,b){
        var A=DATA[(a.getAttribute('href')||'').split('/products/')[1]]||{}, B=DATA[(b.getAttribute('href')||'').split('/products/')[1]]||{};
        if(sort==='low') return (A.price||0)-(B.price||0);
        if(sort==='high') return (B.price||0)-(A.price||0);
        if(sort==='disc') return (B.disc||0)-(A.disc||0);
        return String(B.created).localeCompare(String(A.created));
      });
      grid.style.display='grid';
      vis.forEach(function(c,i){ c.style.order=i; });
    }
    try{ uzRefreshColour(cl.length?cl[0]:null); }catch(e){}
    var cnt=document.getElementById('uz-count'); if(cnt) cnt.textContent=shown+' styles';
    var em=document.getElementById('uz-empty'); if(em) em.classList.toggle('uz-hide',shown>0);
    [].forEach.call(document.querySelectorAll('#uz-bar .uz-btn'),function(b){
      var id=b.getAttribute('data-pop');
      var active=(id==='uz-size'&&sz.length)||(id==='uz-col'&&cl.length)||(id==='uz-price'&&(mn>0||mx<1e9))||(id==='uz-sort'&&sort!=='featured');
      b.classList.toggle('on',!!active);
    });
  }

  var pages=[1,2,3], done=0, all=[];
  pages.forEach(function(pg){
    fetch('/collections/'+handle+'/products.json?limit=250&page='+pg)
      .then(function(r){return r.json();})
      .then(function(j){ all=all.concat(j.products||[]); })
      .catch(function(){})
      .then(function(){ done++; if(done===pages.length){ harvest(all); build(); apply(); try{ initCardGallery(cards,DATA); }catch(e){} } });
  });
}


/* ---------- PRODUCT PAGE ---------- */
var PCSS=[
'.uz-trust{margin:14px 0 4px;border:1px solid #e7e2da;border-radius:12px;overflow:hidden;background:#fdfcfa}',
'.uz-trust div{display:flex;gap:10px;align-items:flex-start;padding:11px 14px;font-size:14px;line-height:1.45;border-bottom:1px solid #efeae1}',
'.uz-trust div:last-child{border-bottom:0}',
'.uz-trust b{font-weight:600}',
'.uz-trust i{font-style:normal;flex:0 0 18px;text-align:center}',
'.uz-cats{display:flex;gap:8px;overflow-x:auto;padding:10px 20px;border-bottom:1px solid #e7e2da;background:#fff;-webkit-overflow-scrolling:touch}',
'.uz-cats a{flex:0 0 auto;font-size:13px;letter-spacing:.4px;text-transform:uppercase;color:#333;text-decoration:none;padding:7px 14px;border:1px solid #e0d9cd;border-radius:999px;white-space:nowrap}',
'.uz-cats a:hover{background:#222;color:#fff;border-color:#222}',
'.uz-rec{padding:34px 20px 46px;border-top:1px solid #e7e2da;margin-top:34px}',
'.uz-rec h2{font-size:14px;letter-spacing:2.5px;text-transform:uppercase;color:#7A5C1E;margin:0 0 20px;font-weight:500;text-align:center}',
'.uz-recg{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;max-width:1100px;margin:0 auto}',
'.uz-recg a{text-decoration:none;color:#222}',
'.uz-recg img{width:100%;aspect-ratio:1/1;object-fit:contain;background:#fff;border-radius:10px;display:block}',
'.uz-recg h3{font-size:14px;margin:9px 0 3px;font-weight:400;line-height:1.35}',
'.uz-recg p{margin:0;font-size:14px}',
'.uz-recg s{color:#999;margin-left:6px;font-size:13px}',
'@media(max-width:700px){.uz-recg{grid-template-columns:repeat(2,1fr)}.uz-cats{padding:8px 12px}}',
'.uz-sticky{position:fixed;left:0;right:0;bottom:0;background:#fff;border-top:1px solid #e7e2da;padding:10px 14px;display:none;gap:12px;align-items:center;z-index:9000;box-shadow:0 -6px 18px rgba(0,0,0,.07)}',
'.uz-sticky img{width:44px;height:44px;object-fit:contain;border-radius:7px}',
'.uz-sticky .t{flex:1;min-width:0}',
'.uz-sticky .t b{display:block;font-size:13px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
'.uz-sticky .t span{font-size:13px;color:#7A5C1E}',
'.uz-sticky button{font:inherit;font-size:15px;padding:13px 22px;border:0;border-radius:9px;background:#222;color:#fff;cursor:pointer}',
'@media(max-width:820px){.uz-sticky.show{display:flex}body.uz-pad{padding-bottom:74px}}'
].join('');

function initProduct(){
  var pdp=document.querySelector('section.pdp'); if(!pdp) return;
  if(document.getElementById('uz-pcss')) return;
  var st=document.createElement('style'); st.id='uz-pcss'; st.textContent=PCSS; document.head.appendChild(st);

  /* 1. Size labels: 3/36 -> UK 3 . EU 36 */
  [].forEach.call(pdp.querySelectorAll('.pszb'),function(b){
    var m=b.textContent.trim().match(/^(\d+)\s*\/\s*(\d+)$/);
    if(m) b.innerHTML='UK '+m[1]+'<small style="opacity:.55;font-size:11px;display:block;line-height:1">EU '+m[2]+'</small>';
  });

  /* 2. Force an explicit size choice - no accidental default */
  var buy=document.getElementById('pbuy');
  var chosen=false;
  var szs=[].slice.call(pdp.querySelectorAll('.pszb'));
  if(buy&&szs.length){
    szs.forEach(function(b){b.classList.remove('on');});
    buy.dataset.uzLabel='Add to bag';
    buy.textContent='Select your size';
    buy.style.opacity='.55';
    pdp.addEventListener('click',function(e){
      var b=e.target.closest('.pszb'); if(!b) return;
      chosen=true;
      buy.style.opacity='1';
      buy.textContent='Add to bag \u00b7 '+(b.textContent.replace(/EU.*/,'').trim());
      var sb=document.querySelector('.uz-sticky button'); if(sb) sb.textContent='Add to bag';
    });
    buy.addEventListener('click',function(e){
      if(!chosen){ e.preventDefault(); e.stopPropagation();
        var box=pdp.querySelector('.pszs');
        if(box){ box.scrollIntoView({behavior:'smooth',block:'center'});
          box.style.transition='box-shadow .25s'; box.style.boxShadow='0 0 0 3px #D22630';
          setTimeout(function(){box.style.boxShadow='none';},1400); }
      }
    },true);
  }

  /* 3. Trust block above the description */
  var note=pdp.querySelector('.pnote');
  var trust=document.createElement('div');
  trust.className='uz-trust';
  trust.innerHTML=
   '<div><i>\u{1F3EC}</i><span><b>Collect from the shop today.</b> In stock at 286 Green Street, London E7 8LF. Open Monday to Saturday, 10:30am to 7pm. No delivery charge, no waiting.</span></div>'+
   '<div><i>\u{1F69A}</i><span><b>Free UK delivery over \u00a380.</b> \u00a33.50 standard (3\u20134 working days), \u00a34.99 for 24 hours, \u00a35.99 guaranteed before 1pm. Order by 1:30pm, sent the same working day.</span></div>'+
   '<div><i>\u{21BA}</i><span><b>Wrong size? Swap it, no fuss.</b> 30 days to return or exchange, in the shop or by post. Try them on at home first.</span></div>'+
   '<div><i>\u{1F4AC}</i><span><b>Not sure of your size?</b> Ask Sara, our shop assistant, bottom right of your screen. Or call the shop on 0208 552 6586.</span></div>';
  if(note&&note.parentElement) note.parentElement.insertBefore(trust,note.nextSibling);

  /* 4. Sticky add to bag on mobile */
  var img=document.getElementById('pmimg');
  var h1=pdp.querySelector('h1');
  var bar=document.createElement('div');
  bar.className='uz-sticky';
  bar.innerHTML='<img src="'+((img&&img.getAttribute('src'))||'')+'" alt=""><div class="t"><b>'+((h1&&h1.textContent)||'')+
    '</b><span id="uz-sp">'+((document.getElementById('pprice')||{textContent:''}).textContent)+'</span></div><button type="button">Select your size</button>';
  document.body.appendChild(bar);
  document.body.classList.add('uz-pad');
  bar.querySelector('button').addEventListener('click',function(){ if(buy) buy.click(); });
  window.addEventListener('scroll',function(){
    if(!buy) return;
    var r=buy.getBoundingClientRect();
    bar.classList.toggle('show', r.bottom<0 || r.top>window.innerHeight);
  },{passive:true});

  /* 5. Sideways category strip under the nav */
  var nav=document.querySelector('nav');
  var women=[].slice.call(document.querySelectorAll('nav .ddm a'));
  if(nav&&women.length){
    var strip=document.createElement('div'); strip.className='uz-cats';
    strip.innerHTML=women.slice(0,14).map(function(a){
      return '<a href="'+a.getAttribute('href')+'">'+a.textContent.trim()+'</a>';
    }).join('');
    pdp.parentElement.insertBefore(strip,pdp);
    var np=getComputedStyle(nav).position;
    if(np==='fixed'||np==='absolute'){ strip.style.paddingTop=(nav.offsetHeight+12)+'px'; }
  }

  /* 6. You may also like */
  var handle=(location.pathname.match(/\/products\/([^\/?#]+)/)||[])[1];
  if(!handle) return;
  fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(p){
    return fetch('/recommendations/products.json?product_id='+p.id+'&limit=4&intent=related').then(function(r){return r.json();});
  }).then(function(j){
    var items=(j&&j.products)||[]; if(!items.length) return;
    var wrap=document.createElement('section'); wrap.className='uz-rec';
    wrap.innerHTML='<h2>Goes well with this</h2><div class="uz-recg">'+items.map(function(p){
      var im=(p.featured_image||(p.images&&p.images[0])||'');
      var pr=(p.price/100).toFixed(2), ca=p.compare_at_price?(p.compare_at_price/100).toFixed(2):null;
      return '<a href="'+p.url+'"><img loading="lazy" src="'+im+'" alt=""><h3>'+p.title+
        '</h3><p><strong>\u00a3'+pr+'</strong>'+(ca&&ca>pr?'<s>\u00a3'+ca+'</s>':'')+'</p></a>';
    }).join('')+'</div>';
    (pdp.parentElement||document.body).insertBefore(wrap,pdp.nextSibling);
  }).catch(function(){});
}


/* ---------- HOMEPAGE ---------- */
var HCSS=[
'.uz-her{display:flex;gap:26px;justify-content:center;flex-wrap:wrap;padding:16px 20px;background:#faf7f2;border-top:1px solid #efeae1;border-bottom:1px solid #efeae1;font-size:13.5px;color:#5b5145;letter-spacing:.3px;text-align:center}',
'.uz-her span{white-space:nowrap}',
'.uz-her b{color:#7A5C1E;font-weight:600}',
'.uz-reels{padding:38px 0 30px}',
'.uz-reels h2{font-size:15px;letter-spacing:2.5px;text-transform:uppercase;text-align:center;margin:0 0 6px;font-weight:500;color:#222}',
'.uz-reels p.sub{text-align:center;margin:0 0 22px;font-size:14px;color:#7a7268}',
'.uz-track{display:flex;gap:14px;overflow-x:auto;padding:2px 20px 14px;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch}',
'.uz-track::-webkit-scrollbar{height:6px}.uz-track::-webkit-scrollbar-thumb{background:#ded7cb;border-radius:6px}',
'.uz-reel{flex:0 0 208px;scroll-snap-align:start;text-decoration:none;color:#222}',
'.uz-reel video{width:208px;height:370px;object-fit:cover;border-radius:14px;background:#f2efe9;display:block}',
'.uz-reel h3{font-size:14px;font-weight:400;margin:9px 0 3px;line-height:1.35}',
'.uz-reel .pz{font-size:14px}.uz-reel .pz s{color:#999;margin-left:6px;font-size:13px}',
'.uz-reel .tag{display:inline-block;background:#222;color:#fff;font-size:11.5px;padding:3px 9px;border-radius:5px;margin-top:5px;letter-spacing:.5px}',
'@media(max-width:700px){.uz-reel{flex:0 0 168px}.uz-reel video{width:168px;height:299px}.uz-track{padding:2px 12px 14px}.uz-her{gap:14px;font-size:12.5px}}'
].join('');

function initHome(){
  if(document.getElementById('uz-hcss')) return;
  var st=document.createElement('style'); st.id='uz-hcss'; st.textContent=HCSS; document.head.appendChild(st);

  /* Heritage strip straight under the hero */
  var nav=document.querySelector('nav');
  var her=document.createElement('div'); her.className='uz-her';
  her.innerHTML='<span><b>Since 1989</b> \u00b7 286 Green Street, London</span>'+
   '<span>Free UK delivery over \u00a380</span>'+
   '<span>Collect from the shop the same day</span>'+
   '<span>30 day returns and exchanges</span>';
  var hero=document.querySelector('section, .hero, header + div');
  if(hero&&hero.parentElement) hero.parentElement.insertBefore(her,hero.nextSibling);
  else if(nav) nav.parentElement.insertBefore(her,nav.nextSibling);

  /* Shoppable video row - reads /pages/shop-by-video, one line per clip: handle|video file link */
  fetch('/pages/shop-by-video').then(function(r){ if(!r.ok) throw 0; return r.text(); }).then(function(html){
    var d=document.createElement('div'); d.innerHTML=html;
    var body=(d.querySelector('.rte, .page-content, main')||d).textContent||'';
    var rows=body.split('\n').map(function(l){return l.trim();}).filter(function(l){return l.indexOf('|')>0 && /\.(mp4|mov|webm)/i.test(l);});
    if(!rows.length) return;
    var sec=document.createElement('section'); sec.className='uz-reels';
    sec.innerHTML='<h2>See them on</h2><p class="sub">Filmed in the shop on Green Street. Tap any clip to shop it.</p><div class="uz-track" id="uz-track"></div>';
    var anchor=document.querySelector('.uz-her');
    if(anchor&&anchor.parentElement) anchor.parentElement.insertBefore(sec,anchor.nextSibling); else document.body.appendChild(sec);
    var track=sec.querySelector('#uz-track');
    rows.slice(0,18).forEach(function(line){
      var p=line.split('|'); var handle=p[0].trim(); var src=p[1].trim();
      fetch('/products/'+handle+'.js').then(function(r){return r.json();}).then(function(pr){
        var price=(pr.price/100).toFixed(2), ca=pr.compare_at_price?(pr.compare_at_price/100).toFixed(2):null;
        var off=(ca&&ca>price)?Math.round((1-price/ca)*100):0;
        var a=document.createElement('a'); a.className='uz-reel'; a.href='/products/'+handle;
        a.innerHTML='<video src="'+src+'" autoplay loop muted playsinline preload="metadata"></video>'+
          '<h3>'+pr.title+'</h3><div class="pz"><strong>\u00a3'+price+'</strong>'+(ca&&ca>price?'<s>\u00a3'+ca+'</s>':'')+'</div>'+
          (off?'<span class="tag">'+off+'% off</span>':'');
        track.appendChild(a);
      }).catch(function(){});
    });
  }).catch(function(){});
}


/* ---------- ANGLE GALLERY ON THE PRODUCT CARD ---------- */
var GCSS=[
'.ph{position:relative;overflow:hidden}',
'.uz-dots{position:absolute;left:0;right:0;bottom:8px;display:flex;gap:5px;justify-content:center;pointer-events:none;z-index:3}',
'.uz-dot{width:6px;height:6px;border-radius:50%;background:rgba(0,0,0,.22);transition:background .18s,transform .18s}',
'.uz-dot.on{background:#222;transform:scale(1.35)}',
'.uz-arw{position:absolute;top:50%;transform:translateY(-50%);width:30px;height:30px;border-radius:50%;border:0;background:rgba(255,255,255,.9);box-shadow:0 2px 8px rgba(0,0,0,.14);cursor:pointer;display:none;align-items:center;justify-content:center;z-index:4;padding:0;color:#222;font-size:15px;line-height:1}',
'.uz-arw.l{left:8px}.uz-arw.r{right:8px}',
'.ph:hover .uz-arw{display:flex}',
'.uz-ang{position:absolute;top:8px;right:8px;background:rgba(255,255,255,.92);color:#555;font-size:10.5px;letter-spacing:.6px;padding:3px 8px;border-radius:20px;z-index:3;pointer-events:none}',
'@media(max-width:820px){.uz-arw{display:none !important}.uz-dot{width:7px;height:7px}}'
].join('');


function uzImgsFor(d,want){
  if(!d||!d.blocks||!d.blocks.o||!d.blocks.o.length) return (d&&d.imgs)||[];
  var b=d.blocks.b,o=d.blocks.o,k,i;
  if(want){ want=String(want).toLowerCase();
    for(i=0;i<o.length;i++){ if(o[i]===want) return b[o[i]]; }
    for(i=0;i<o.length;i++){ if(o[i].indexOf(want)>-1||want.indexOf(o[i])>-1) return b[o[i]]; }
  }
  for(i=0;i<o.length;i++){ if(/gold/.test(o[i]) && !/rose/.test(o[i])) return b[o[i]]; }
  for(i=0;i<o.length;i++){ if(/gold|champagne|bronze/.test(o[i])) return b[o[i]]; }
  return b[o[0]]||d.imgs||[];
}
function uzRefreshColour(want){
  [].forEach.call(document.querySelectorAll('.ph'),function(ph){ if(ph._uzSet) ph._uzSet(want); });
}
function initCardGallery(cards,DATA){
  if(!document.getElementById('uz-gcss')){ var g=document.createElement('style'); g.id='uz-gcss'; g.textContent=GCSS; document.head.appendChild(g); }
  cards.forEach(function(card){
    var h=(card.getAttribute('href')||'').split('/products/')[1];
    var d=DATA[h]; if(!d||!d.imgs||d.imgs.length<2) return;
    var ph=card.querySelector('.ph'); if(!ph||ph.dataset.uz) return;
    ph.dataset.uz='1';
    var el=ph.querySelector('img'); if(!el) return;
    el.removeAttribute('srcset'); el.removeAttribute('sizes');
    var imgs=uzImgsFor(d,null).slice(0,6), idx=0, lock=false;
    ph._uzD=d;

    var dots=document.createElement('div'); dots.className='uz-dots';
    imgs.forEach(function(_,i){ var s=document.createElement('span'); s.className='uz-dot'+(i?'':' on'); dots.appendChild(s); });
    ph.appendChild(dots);
    var tag=document.createElement('span'); tag.className='uz-ang'; tag.textContent=imgs.length+' angles'; ph.appendChild(tag);

    function arrow(cls,txt,step){
      var b=document.createElement('button');
      b.type='button'; b.className='uz-arw '+cls; b.innerHTML=txt; b.setAttribute('aria-label','Next angle');
      b.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); go(idx+step); });
      ph.appendChild(b); return b;
    }
    function go(n){
      idx=(n+imgs.length)%imgs.length;
      el.src=imgs[idx];
      [].forEach.call(dots.children,function(s,i){ s.classList.toggle('on',i===idx); });
      tag.textContent=(idx+1)+' of '+imgs.length;
    }
    arrow('l','\u2039',-1); arrow('r','\u203A',1);
    ph._uzSet=function(want){
      var list=uzImgsFor(ph._uzD,want).slice(0,6);
      if(!list.length) return;
      imgs=list; idx=0;
      dots.innerHTML='';
      imgs.forEach(function(_,i){ var sp=document.createElement('span'); sp.className='uz-dot'+(i?'':' on'); dots.appendChild(sp); });
      el.src=imgs[0];
      tag.textContent=imgs.length+' angles';
    };
    ph._uzSet(null);

    imgs.slice(0,3).forEach(function(u){ var p=new Image(); p.src=u; });

    ph.addEventListener('mouseenter',function(){ if(window.innerWidth>820&&idx===0) go(1); });
    ph.addEventListener('mouseleave',function(){ if(window.innerWidth>820) go(0); });

    var x0=null,y0=null;
    ph.addEventListener('touchstart',function(e){ x0=e.touches[0].clientX; y0=e.touches[0].clientY; },{passive:true});
    ph.addEventListener('touchend',function(e){
      if(x0===null) return;
      var dx=e.changedTouches[0].clientX-x0, dy=e.changedTouches[0].clientY-y0;
      x0=null;
      if(Math.abs(dx)>34 && Math.abs(dx)>Math.abs(dy)*1.4){
        go(idx+(dx<0?1:-1));
        lock=true; setTimeout(function(){ lock=false; },450);
      }
    },{passive:true});
    card.addEventListener('click',function(e){ if(lock){ e.preventDefault(); e.stopPropagation(); } },true);
  });
}

/* ---------- SHARE AND WHATSAPP ON THE PRODUCT PAGE ---------- */
var SCSS=[
'.uz-share{margin:18px 0 6px;padding-top:16px;border-top:1px solid #efeae1}',
'.uz-share .lb{font-size:11.5px;letter-spacing:2px;text-transform:uppercase;color:#8b8175;margin-bottom:10px}',
'.uz-srow{display:flex;gap:9px;flex-wrap:wrap}',
'.uz-srow a,.uz-srow button{display:inline-flex;align-items:center;gap:7px;font:inherit;font-size:13.5px;padding:9px 15px;border:1px solid #e0d9cd;border-radius:999px;background:#fff;color:#333;text-decoration:none;cursor:pointer;line-height:1}',
'.uz-srow a:hover,.uz-srow button:hover{border-color:#bfb5a4;background:#fdfcfa}',
'.uz-srow svg{width:15px;height:15px;flex:0 0 15px}',
'.uz-ask{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;margin-top:12px;padding:14px 18px;border-radius:10px;background:#25D366;color:#fff;font-size:15px;text-decoration:none;border:0}',
'.uz-ask:hover{background:#1fb955}',
'.uz-ask svg{width:19px;height:19px;fill:#fff}'
].join('');

function initShare(){
  var pdp=document.querySelector('section.pdp'); if(!pdp) return;
  if(pdp.querySelector('.uz-share')) return;
  if(!document.getElementById('uz-scss')){ var s=document.createElement('style'); s.id='uz-scss'; s.textContent=SCSS; document.head.appendChild(s); }
  var h1=pdp.querySelector('h1'); var title=h1?h1.textContent.trim():document.title;
  var url=location.origin+location.pathname;
  var WA='M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 004.79 1.22h.01c5.46 0 9.9-4.45 9.9-9.91C21.95 6.45 17.5 2 12.04 2zm5.8 14.16c-.24.68-1.42 1.32-1.95 1.37-.5.05-.97.23-3.27-.68-2.75-1.08-4.5-3.9-4.64-4.08-.13-.18-1.1-1.47-1.1-2.8 0-1.33.7-1.98.94-2.25.25-.27.54-.34.72-.34.18 0 .36 0 .52.01.17.01.39-.06.61.47.23.55.78 1.9.85 2.04.07.14.11.3.02.48-.09.18-.14.29-.27.45-.14.16-.29.35-.41.47-.14.13-.28.28-.12.55.16.27.71 1.17 1.52 1.9 1.05.93 1.93 1.22 2.2 1.36.27.14.43.11.59-.07.16-.18.68-.79.86-1.06.18-.27.36-.23.61-.14.25.09 1.6.75 1.87.89.27.14.45.2.52.32.07.11.07.64-.17 1.31z';
  var box=document.createElement('div'); box.className='uz-share';
  box.innerHTML='<div class="lb">Share this pair</div><div class="uz-srow">'+
    
    '<a target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url)+'"><svg viewBox="0 0 24 24" fill="#1877F2"><path d="M22 12a10 10 0 10-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0022 12z"/></svg>Facebook</a>'+
    '<a target="_blank" rel="noopener" href="https://www.instagram.com/shalimar_shoes_official/"><svg viewBox="0 0 24 24" fill="none" stroke="#C13584" stroke-width="1.9"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r="1.1" fill="#C13584" stroke="none"/></svg>Instagram</a>'+
    '<button type="button" id="uz-copy"><svg viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="1.9"><rect x="9" y="9" width="12" height="12" rx="2.5"/><path d="M5 15V5a2 2 0 012-2h10"/></svg>Copy link</button>'+
    '</div>'+
    '';
  var trust=pdp.querySelector('.uz-trust');
  if(trust&&trust.parentElement) trust.parentElement.insertBefore(box,trust.nextSibling);
  else { var desc=pdp.querySelector('.pdesc'); if(desc&&desc.parentElement) desc.parentElement.insertBefore(box,desc); }
  var cp=document.getElementById('uz-copy');
  if(cp) cp.addEventListener('click',function(){
    var done=function(){ cp.lastChild.textContent='Link copied'; setTimeout(function(){ cp.lastChild.textContent='Copy link'; },1800); };
    if(navigator.clipboard&&navigator.clipboard.writeText){ navigator.clipboard.writeText(url).then(done).catch(function(){}); }
    else { var t=document.createElement('textarea'); t.value=url; document.body.appendChild(t); t.select(); try{document.execCommand('copy');done();}catch(e){} t.remove(); }
  });
}



/* ---------- HOMEPAGE: GOLD FIRST IN EVERY ROW ---------- */
var UZGOLD={map:null,ready:false};
function uzRank(s){
  s=String(s||'').toLowerCase();
  if(/gold|golden/.test(s)) return 0;
  if(/champagne|bronze|copper|mustard|camel/.test(s)) return 1;
  if(/silver|grey|gray|pewter|steel/.test(s)) return 4;
  return -1;
}
function uzApplyGold(){
  var tracks=[].slice.call(document.querySelectorAll('.ctrack'));
  tracks.forEach(function(tr){
    var cards=[].slice.call(tr.querySelectorAll('a.ccard'));
    if(cards.length<3) return;
    var scored=cards.map(function(a,i){
      var im=a.querySelector('img');
      var src=im?(im.getAttribute('src')||im.currentSrc||''):'';
      var file=src.split('/').pop().split('?')[0].replace(/\.[a-z]+$/i,'');
      var r=uzRank(file);
      if(r<0){
        var art=file.split(/[-_]/)[0].toLowerCase();
        r=uzRank((UZGOLD.map&&UZGOLD.map[art])||'');
      }
      if(r<0) r=2;
      return {a:a,r:r,i:i};
    });
    scored.sort(function(x,y){ return x.r-y.r || x.i-y.i; });
    scored.forEach(function(o,i){ o.a.style.order=i; });
    tr.scrollLeft=0;
  });
}
function uzHomeGoldImages(){
  var seen={};
  function grab(page){
    return fetch('/collections/all/products.json?limit=250&page='+page).then(function(r){return r.ok?r.json():{products:[]};}).then(function(j){ return j.products||[]; }).catch(function(){ return []; });
  }
  Promise.all([grab(1),grab(2)]).then(function(res){
    var map={};
    res[0].concat(res[1]).forEach(function(p){
      var vc={}; (p.variants||[]).forEach(function(v){ vc[v.id]=String(v.option1||'').toLowerCase(); });
      var gold=null, first=null;
      (p.images||[]).slice().sort(function(a,b){return (a.position||0)-(b.position||0);}).forEach(function(im){
        var f=String(im.src).split('/').pop().split('?')[0];
        if(!first) first=im.src;
        var ids=im.variant_ids||[];
        if(!gold && ids.length){ var c=vc[ids[0]]||''; if(/gold/.test(c)&&!/rose/.test(c)) gold=im.src; }
        if(!gold && /[-_]gold/i.test(f)) gold=im.src;
      });
      if(!gold) return;
      (p.images||[]).forEach(function(im){
        var a=String(im.src).split('/').pop().split('?')[0].replace(/\.[a-z]+$/i,'').split(/[-_]/)[0].toLowerCase();
        if(a && !map[a]) map[a]=gold;
      });
    });
    function swap(){
      [].forEach.call(document.querySelectorAll('a.ccard img'),function(im){
        var src=im.getAttribute('src')||''; if(!src||seen[src]) return;
        var art=src.split('/').pop().split('?')[0].replace(/\.[a-z]+$/i,'').split(/[-_]/)[0].toLowerCase();
        var g=map[art];
        if(g && g.split('?')[0]!==src.split('?')[0]){ seen[g]=1; im.removeAttribute('srcset'); im.setAttribute('src',g.split('?')[0]+'?width=700'); }
      });
    }
    swap(); [700,1800,3500,6000].forEach(function(d){ setTimeout(swap,d); });
  });
}
function initHomeGold(){
  try{ uzHomeGoldImages(); }catch(e){}
  if(!document.querySelector('.ctrack')) return;
  if(window.__uzGoldInit) return;
  window.__uzGoldInit=true;
  fetch('/pages/sara-catalog').then(function(r){ return r.ok?r.text():''; }).then(function(tx){
    var m={};
    String(tx).split('\n').forEach(function(ln){
      var p=ln.split('|'); if(p.length<6) return;
      var cols=(p[5]||'').toLowerCase();
      (p[2]||'').toLowerCase().split(/[\s,]+/).forEach(function(a){ a=a.trim(); if(a) m[a]=(m[a]?m[a]+' ':'')+cols; });
    });
    UZGOLD.map=m; UZGOLD.ready=true;
  }).catch(function(){ UZGOLD.map={}; UZGOLD.ready=true; })
  .then(function(){
    uzApplyGold();
    [800,2000,4000,7000].forEach(function(d){ setTimeout(uzApplyGold,d); });
    var host=document.getElementById('rows')||document.body;
    var t=null;
    new MutationObserver(function(){ clearTimeout(t); t=setTimeout(uzApplyGold,250); })
      .observe(host,{childList:true,subtree:true});
  });
}

/* ---------- PRODUCT PAGE: ALL ANGLES AT ONCE (Faire style) ---------- */
var AGCSS=[
'.uz-ag{display:grid;grid-template-columns:1fr 1fr;gap:8px}',
'.uz-ag figure{margin:0;background:#fff;border-radius:10px;overflow:hidden;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center;cursor:zoom-in}',
'.uz-ag img{width:100%;height:100%;object-fit:contain;display:block}',
'.uz-agmore{grid-column:1 / -1;text-align:center;font:inherit;font-size:13px;padding:11px;border:1px solid #e0d9cd;background:#fff;border-radius:9px;cursor:pointer;color:#333}',
'.uz-lb{position:fixed;inset:0;background:rgba(20,18,16,.92);z-index:100001;display:none;align-items:center;justify-content:center;padding:24px}',
'.uz-lb.on{display:flex}',
'.uz-lb img{max-width:94vw;max-height:92vh;object-fit:contain}',
'.uz-lb .x{position:absolute;top:16px;right:20px;color:#fff;font-size:30px;line-height:1;cursor:pointer;background:none;border:0}',
'@media(max-width:820px){.uz-ag{grid-template-columns:1fr}}'
].join('');

function uzAngleGrid(){
  var media=document.querySelector('.pdp-media'); if(!media) return;
  if(media.dataset.uzAg==='1') return;
  var thumbs=[].slice.call(document.querySelectorAll('#pthumbs .pth img'));
  var main=document.getElementById('pmimg');
  var strip=function(u){ return String(u).split('?')[0].replace(/_(\d+)x(?=\.[a-z0-9]+$)/i,''); };
  var srcs=thumbs.map(function(i){return strip(i.getAttribute('src')||'');}).filter(Boolean);
  if(!srcs.length && main) srcs=[strip(main.getAttribute('src')||'')];
  srcs=srcs.filter(function(v,i,a){return a.indexOf(v)===i;});
  if(srcs.length<2) return;
  media.dataset.uzAg='1';

  if(!document.getElementById('uz-agcss')){ var st=document.createElement('style'); st.id='uz-agcss'; st.textContent=AGCSS; document.head.appendChild(st); }

  var pmain=media.querySelector('.pmain'); if(pmain) pmain.style.display='none';
  var pth=document.getElementById('pthumbs'); if(pth) pth.style.display='none';

  var grid=document.createElement('div'); grid.className='uz-ag';
  var LIMIT=4, shown=0;
  function tile(src){
    var f=document.createElement('figure');
    var im=document.createElement('img');
    im.loading='lazy'; im.src=src+'?width=900'; im.alt='';
    im.addEventListener('click',function(){ openLb(src); });
    f.appendChild(im); return f;
  }
  function render(){
    var more=grid.querySelector('.uz-agmore'); if(more) more.remove();
    var end=Math.min(srcs.length, shown+LIMIT);
    for(var i=shown;i<end;i++) grid.appendChild(tile(srcs[i]));
    shown=end;
    if(shown<srcs.length){
      var b=document.createElement('button');
      b.type='button'; b.className='uz-agmore';
      b.textContent='Show all '+srcs.length+' angles';
      b.addEventListener('click',function(){ LIMIT=srcs.length; render(); });
      grid.appendChild(b);
    }
  }
  render();
  media.appendChild(grid);

  var lb=document.createElement('div'); lb.className='uz-lb';
  lb.innerHTML='<button class="x" aria-label="Close">&times;</button><img alt="">';
  document.body.appendChild(lb);
  function openLb(src){ lb.querySelector('img').src=src+'?width=1800'; lb.classList.add('on'); }
  lb.addEventListener('click',function(){ lb.classList.remove('on'); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') lb.classList.remove('on'); });
}


/* ---------- QUICK VIEW v3: colour-aware images, correct URLs, robust mobile ---------- */
var QVCSS=[
'.uzq-trust{margin:16px 0 0;border:1px solid #EBE3D4;border-radius:12px;overflow:hidden;background:#fff}',
'.uzq-trust div{display:flex;gap:10px;align-items:flex-start;padding:10px 13px;font-size:13px;line-height:1.5;border-bottom:1px solid #F2ECDF;color:#3d3a35}',
'.uzq-trust div:last-child{border-bottom:0}',
'.uzq-trust b{font-weight:600;color:#262628}',
'.uzq-trust i{font-style:normal;flex:0 0 16px;text-align:center;color:#B98A2F}',
'.uzq-share{margin:14px 0 4px}',
'.uzq-share .lb{font-size:10px;letter-spacing:2.2px;text-transform:uppercase;color:#8b8175;font-weight:700;margin-bottom:8px}',
'.uzq-row{display:flex;gap:8px;flex-wrap:wrap}',
'.uzq-row a,.uzq-row button{display:inline-flex;align-items:center;gap:6px;font:inherit;font-size:12.5px;padding:8px 14px;border:1px solid #E0D9CD;border-radius:999px;background:#fff;color:#333;text-decoration:none;cursor:pointer;line-height:1}',
'@media(min-width:821px){',
'#pmleft .uzq-grid{display:grid;grid-template-columns:1fr 1fr;gap:8px}',
'#pmleft .uzq-grid figure{margin:0;background:#fff;border-radius:10px;overflow:hidden;aspect-ratio:1/1;display:flex;align-items:center;justify-content:center}',
'#pmleft .uzq-grid img{width:100%;height:100%;object-fit:contain;display:block}',
'}'
].join('');
var UZQV={handle:null,data:null,blocks:null};
(function wrapOP(){
  if(typeof window.openProduct==='function' && !window.openProduct.__uz){
    var _op=window.openProduct;
    window.openProduct=function(h){ try{ UZQV.handle=String(h||'').split(/[?#]/)[0]; UZQV.data=null; UZQV.blocks=null; }catch(e){} return _op.apply(this,arguments); };
    window.openProduct.__uz=1;
  } else if(!window.openProduct||!window.openProduct.__uz){ setTimeout(wrapOP,600); }
})();
document.addEventListener('click',function(e){
  var a=e.target.closest('a.card, a.ccard');
  if(a){ var h=(a.getAttribute('href')||'').split('/products/')[1]; if(h){ UZQV.handle=h.split(/[?#]/)[0]; UZQV.data=null; UZQV.blocks=null; } }
},true);
function uzqBlocks(p){
  var vc={}; (p.variants||[]).forEach(function(v){ vc[v.id]=String(v.option1||'').trim(); });
  var order=[], blocks={}, cur=null;
  (p.images||[]).slice().sort(function(a,b){return (a.position||0)-(b.position||0);}).forEach(function(im){
    var ids=im.variant_ids||[];
    if(ids.length){ var c=vc[ids[0]]||''; if(c){ cur=c; if(!blocks[c]){blocks[c]=[]; order.push(c);} } }
    if(cur && blocks[cur].length<6) blocks[cur].push(String(im.src).split('?')[0]);
  });
  return {o:order,b:blocks};
}
function uzqApply(colour){
  var bl=UZQV.blocks; if(!bl) return;
  var key=null;
  bl.o.forEach(function(c){ if(String(c).toLowerCase()===String(colour).toLowerCase()) key=c; });
  if(!key) return;
  var list=bl.b[key]||[]; if(!list.length) return;
  var main=document.getElementById('pmimg');
  if(main){ main.src=list[0]+'?width=900'; }
  var th=document.getElementById('pmthumbs');
  if(th){ var tImgs=th.querySelectorAll('img'); [].forEach.call(tImgs,function(im,i){ if(list[i]) im.src=list[i]+'?width=200'; im.parentElement.style.display=list[i]?'':'none'; }); }
  var g=document.querySelector('#pmleft .uzq-grid');
  if(g){ g.innerHTML=''; list.slice(0,4).forEach(function(u){ var f=document.createElement('figure'); var im=document.createElement('img'); im.loading='lazy'; im.src=u+'?width=700'; f.appendChild(im); g.appendChild(f); }); }
}
function uzQuickView(){
  var modal=document.getElementById('pmodal'); if(!modal) return;
  if(!document.getElementById('uzq-css')){ var st=document.createElement('style'); st.id='uzq-css'; st.textContent=QVCSS; document.head.appendChild(st); }
  modal.addEventListener('click',function(e){
    var t=e.target.closest('button,[role="button"],span,div');
    if(!t) return;
    var txt=(t.textContent||'').trim();
    if(!txt||txt.length>20) return;
    if(UZQV.blocks && UZQV.blocks.o.some(function(c){return c.toLowerCase()===txt.toLowerCase();})){
      setTimeout(function(){ uzqApply(txt); },120);
    }
  },true);
  function ensureData(){
    if(!UZQV.handle||UZQV.data) return;
    var h=UZQV.handle;
    fetch('/products/'+h+'.json').then(function(r){return r.ok?r.json():null;}).then(function(j2){ var p=j2&&j2.product;
      if(p&&UZQV.handle===h){ UZQV.data=p; UZQV.blocks=uzqBlocks(p); }
    }).catch(function(){});
  }
  function inject(){
    var note=document.getElementById('pmnote'); var body=document.getElementById('pmbody');
    var anchorEl=note||document.getElementById('pmask');
    if(!anchorEl||!body) return;
    ensureData();
    var url=UZQV.handle?(location.origin+'/products/'+UZQV.handle):location.origin;
    var old=body.querySelector('.uzq-share');
    if(old && old.dataset.h!==(UZQV.handle||'')){ old.remove(); var ot=body.querySelector('.uzq-trust'); if(ot) ot.remove(); }
    if(!body.querySelector('.uzq-trust')){
      var trust=document.createElement('div'); trust.className='uzq-trust';
      trust.innerHTML=
       '<div><i>\u25C6</i><span><b>Collect from the shop today.</b> 286 Green Street, London E7 8LF. Mon to Sat, 10:30am to 7pm.</span></div>'+
       '<div><i>\u25C6</i><span><b>Free UK delivery over \u00a380.</b> \u00a33.50 standard, \u00a34.99 for 24 hours, \u00a35.99 guaranteed before 1pm.</span></div>'+
       '<div><i>\u25C6</i><span><b>Wrong size? Swap it.</b> 30 days, in the shop or by post.</span></div>';
      anchorEl.parentElement.insertBefore(trust, anchorEl.nextSibling);
      var box=document.createElement('div'); box.className='uzq-share'; box.dataset.h=UZQV.handle||'';
      box.innerHTML='<div class="lb">Share this pair</div><div class="uzq-row">'+
        '<a target="_blank" rel="noopener" href="https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(url)+'"><svg viewBox="0 0 24 24" fill="#1877F2" width="14" height="14"><path d="M22 12a10 10 0 10-11.56 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.78l-.44 2.89h-2.34v6.99A10 10 0 0022 12z"/></svg>Facebook</a>'+
        '<a target="_blank" rel="noopener" href="https://www.instagram.com/shalimar_shoes_official/"><svg viewBox="0 0 24 24" fill="none" stroke="#C13584" stroke-width="1.9" width="14" height="14"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/></svg>Instagram</a>'+
        '<button type="button" class="uzq-copy"><svg viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="1.9" width="14" height="14"><rect x="9" y="9" width="12" height="12" rx="2.5"/><path d="M5 15V5a2 2 0 012-2h10"/></svg>Copy link</button></div>';
      trust.parentElement.insertBefore(box, trust.nextSibling);
      box.querySelector('.uzq-copy').addEventListener('click',function(){
        var cp=this, u2=UZQV.handle?(location.origin+'/products/'+UZQV.handle):location.origin;
        if(navigator.clipboard){ navigator.clipboard.writeText(u2); cp.lastChild.textContent=' Link copied'; setTimeout(function(){cp.lastChild.textContent=' Copy link';},1600); }
      });
    }
    if(window.innerWidth>820){
      var left=document.getElementById('pmleft');
      if(left && !left.querySelector('.uzq-grid')){
        var thumbs=[].slice.call(left.querySelectorAll('#pmthumbs img'));
        var stripF=function(u){ return String(u).split('?')[0].replace(/_(\d+)x(?=\.[a-z0-9]+$)/i,''); };
        var srcs=thumbs.map(function(i){return stripF(i.getAttribute('src')||'');}).filter(Boolean).filter(function(v,i,a2){return a2.indexOf(v)===i;});
        if(srcs.length>=2){
          var g=document.createElement('div'); g.className='uzq-grid';
          srcs.slice(0,4).forEach(function(u){ var f=document.createElement('figure'); var im=document.createElement('img'); im.loading='lazy'; im.src=u+'?width=700'; f.appendChild(im); g.appendChild(f); });
          var main=document.getElementById('pmimg'); if(main) main.style.display='none';
          var th2=document.getElementById('pmthumbs'); if(th2) th2.style.display='none';
          left.appendChild(g);
        }
      }
    }
  }
  new MutationObserver(function(){ setTimeout(inject,200); }).observe(modal,{childList:true,subtree:true,attributes:true});
  setInterval(function(){ try{ if(getComputedStyle(modal).display!=='none') inject(); }catch(e){} },700);
}

/* ---------- BOOT ---------- */
function boot(){
  try{ initCollection(); }catch(e){}
  try{ initProduct(); }catch(e){}
  try{ initShare(); }catch(e){}
  try{ uzAngleGrid(); }catch(e){}
  try{ uzQuickView(); }catch(e){}
  setTimeout(function(){ try{ uzAngleGrid(); }catch(e){} },1600);
  try{ if(location.pathname==='/'||location.pathname==='') { initHome(); initHomeGold(); } }catch(e){}
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
setTimeout(boot,1500);
})();
